(function () {
    'use strict';

    angular
        .module('adm')
        .controller('ExpensesBySemesterDetailsController', ExpensesBySemesterDetailsController);

    ExpensesBySemesterDetailsController.$inject = ['$uibModalInstance', '$state', 'items'];

    function ExpensesBySemesterDetailsController($uibModalInstance, $state, items) {
        var vm = this;
        vm.activate                         = activate;
        vm.ok                               = ok;
        vm.cancel                           = cancel;
        vm.items                            = items;

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function activate() {

        }
        vm.activate();
    }

})();